import { Link } from "react-router-dom";
import { Feather, Globe2, Library, ArrowRight } from "lucide-react";
import { IMAGES } from "@/lib/images";
import { Ornament } from "@/components/Ornament";

const facts = [
  { icon: Feather, title: "Kim yazdı?", text: "Kâşgarlı Mahmud (Mahmûd bin el-Hüseyin bin Muhammed el-Kâşgarî), Karahanlı soyundan gelen büyük dil bilgini." },
  { icon: Library, title: "Ne zaman?", text: "1072-1074 yılları arasında Bağdat'ta tamamlandı; Abbasi halifesine sunuldu." },
  { icon: Globe2, title: "Neden önemli?", text: "Türkçenin Arapça karşısındaki zenginliğini kanıtlayan, bilinen ilk kapsamlı Türk dili sözlüğü ve kültür ansiklopedisidir." },
];

export default function About() {
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="text-center">
        <span className="eyebrow">Eser Hakkında</span>
        <h1 className="mt-3 font-[Cinzel] text-4xl sm:text-5xl font-bold text-foreground">
          Divânu Lugâti't-Türk
        </h1>
        <p className="mt-2 text-lg rubric italic">“Türk Lehçelerinin Divanı”</p>
        <div className="flex justify-center text-accent mt-6">
          <Ornament className="w-44 h-5" />
        </div>
      </div>

      <div className="mt-8 folio-frame rounded-lg overflow-hidden">
        <img
          src={IMAGES.silkRoad}
          alt="İpek Yolu ve Türk dünyası"
          loading="lazy"
          className="w-full h-56 sm:h-72 object-cover"
        />
      </div>

      <article className="mt-10 folio-frame rounded-lg bg-card p-8 sm:p-12">
        <p className="text-lg leading-relaxed text-foreground/90 drop-cap">
          Divânu Lugâti't-Türk, 11. yüzyılda Kâşgarlı Mahmud tarafından Türk boylarının dilini,
          kültürünü ve coğrafyasını belgelemek için kaleme alınmış eşsiz bir eserdir. Arap
          dünyasına Türkçeyi öğretmek amacıyla Arapça açıklamalarla yazılmış; binlerce kelime,
          atasözü (sav), şiir ve bir de dairesel dünya haritası içerir.
        </p>
        <p className="mt-5 text-lg leading-relaxed text-foreground/90">
          Bu dijital codex, eserin akademik bir kopyası değil; ondan ilham alan, modern bir okuma
          ve keşif deneyimidir. Buradaki kelimeler, savlar ve harita bölgeleri özenle seçilmiş
          örnek bir seçkidir ve eserin ruhunu çağdaş bir arayüzde yaşatmayı amaçlar.
        </p>

        <div className="gold-rule my-8" />

        <div className="grid sm:grid-cols-3 gap-6">
          {facts.map((f) => (
            <div key={f.title} className="rounded-md border border-border p-5">
              <span className="flex items-center justify-center w-10 h-10 rounded-full border border-accent/50 text-accent mb-4">
                <f.icon className="w-4 h-4" />
              </span>
              <h3 className="font-[Cinzel] text-lg font-semibold text-foreground">{f.title}</h3>
              <p className="mt-2 text-sm text-foreground/75 leading-relaxed">{f.text}</p>
            </div>
          ))}
        </div>
      </article>

      <div className="mt-10 flex flex-wrap justify-center gap-4">
        <Link
          to="/sozluk"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary text-primary-foreground font-medium hover:bg-primary/90 transition-colors"
        >
          Sözlüğü Keşfet <ArrowRight className="w-4 h-4" />
        </Link>
        <Link
          to="/harita"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-accent text-foreground hover:bg-accent/10 transition-colors"
        >
          Haritayı Gör
        </Link>
      </div>
    </div>
  );
}
